// 응답 신고(AI 출력 플래그)를 프록시(/api/report)로 보낸다.
// ⚠️ 앱에서 직접 메일/SMTP 금지(자격증명 노출) — 무조건 백엔드 경유. 사람 간 신고 아님(AI 출력 플래그).
import type { Lang } from "./types";

const MOON = (import.meta.env.VITE_MOON_ENDPOINT as string | undefined) ?? "";
// .../api/hyuh → .../api/report
const REPORT_URL = MOON ? MOON.replace(/\/api\/hyuh\/?$/, "/api/report") : "";

export type ReportReason = "weird" | "offensive" | "crisis_false_positive" | "other";
export type ReportBranch = "letter" | "prophecy" | "crisis_safe";

export interface ReportInput {
  reason: ReportReason;
  comment?: string;
  inputText: string; // 직전 고백 원문(클라 현재 상태)
  responseText: string; // 신고 대상 AI 응답 원문
  branch: ReportBranch;
  locale: Lang;
}

function platform(): string {
  const cap = (window as unknown as { Capacitor?: { getPlatform?: () => string } }).Capacitor;
  const p = cap?.getPlatform?.();
  return p === "ios" || p === "android" ? p : "web";
}

/** 신고 전송. 성공 여부 반환(실패 시 호출부가 평문 에러+재시도). */
export async function sendReport(r: ReportInput): Promise<boolean> {
  if (!REPORT_URL) return false;
  try {
    const res = await fetch(REPORT_URL, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        reason: r.reason,
        comment: r.comment ?? "",
        input_text: r.inputText,
        response_text: r.responseText,
        branch: r.branch,
        app_version: typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "",
        platform: platform(),
        locale: r.locale,
        ts: new Date().toISOString(),
      }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
